export function teamDataFilterWrapper(role, ids, data){
    if (!data) {
        return []
    }
    else if (role === 'Administrator') {
        return data
    } else {
       return data.filter(i => ids.includes(i.user_info.id))
    }
}